import { showToast } from '@slices/apiSlice';
import { baseApi } from '@store/baseQuery';

import { BuyPricingPlanResponse, PricingPlans } from '../types';

export const pricing = baseApi.injectEndpoints({
    endpoints: builder => ({
        getPlans: builder.query<PricingPlans, void>({
            query: () => ({
                url: `/plans?offset=0&limit=100&orderBy=planOrder&orderDirection=ASC`,
                method: 'GET',
            }),
            providesTags: ['Plans'],
            keepUnusedDataFor: 0,
            async onQueryStarted(_arg, { dispatch, queryFulfilled }) {
                try {
                    await queryFulfilled;
                } catch (error) {
                    dispatch(showToast({ variant: 'error', description: error?.error }));
                }
            },
        }),
        buyPlan: builder.mutation<BuyPricingPlanResponse, { planId: string }>({
            query: body => ({
                url: '/mentee/plan/buy',
                method: 'POST',
                body,
            }),
        }),
    }),
    overrideExisting: true,
});

export const { useGetPlansQuery, useBuyPlanMutation } = pricing;
